import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import JobSeekerDashboard from './pages/JobSeekerDashboard';
import Header from './components/Header';
import CandidatesList from './CandidatesList';
import CandidateDetails from './CandidateDetails';
import EditJob from './pages/EditJob';
import AddJob from './pages/AddJob';
import JobResults from './pages/JobResults';
import AssessmentsPage from './pages/AssessmentsPage';
import AnalyticalAssessmentPage from './pages/AnalyticalAssessmentPage';
import BehavioralAssessmentPage from './pages/BehavioralAssessmentPage';
import HumanoidModel from './components/HumanoidModel';
import EmployerSignup from './pages/EmployerSignup';
import JobSeekerSignup from './pages/JobSeekerSignup';
import JobSeekerProfileUpdate from './pages/JobSeekerProfileUpdate';
import EmployerProfiles from './pages/EmployerProfiles';
import About from './pages/About';
import ProfilePage from './pages/ProfilePage';
import CandidateResults from "./pages/CandidateResults"; // ✅ Fixed import
import ResultsPage from './pages/ResultsPage'; // ✅ Ensure this is correctly imported

function App() {
    return (
        <div> {/* ✅ No <Router> here anymore */}
            <Header />
            <Routes>
                {/* Homepage */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />

                {/* Authentication */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />

                {/* Employer Dashboard and Related Pages */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/edit-job/:id" element={<EditJob />} />
                <Route path="/add-job" element={<AddJob />} />
                <Route path="/job-results/:id" element={<JobResults />} />
                <Route path="/employer-signup" element={<EmployerSignup />} />
                <Route path="/employer-profiles" element={<EmployerProfiles />} />
                <Route path="/update-profile" element={<ProfilePage />} /> 
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/results/:jobId" element={<ResultsPage />} />  // ✅ Ensure this route exists

                {/* Job Seeker Routes */}
                <Route path="/jobseeker-signup" element={<JobSeekerSignup />} />
                <Route path="/jobseeker-dashboard" element={<JobSeekerDashboard />} />
                <Route path="/jobseeker-update-profile" element={<JobSeekerProfileUpdate />} />

                {/* Candidates and Assessments */}
                <Route path="/candidates" element={<CandidatesList />} />
                <Route path="/candidate/:id" element={<CandidateDetails />} />
                <Route path="/assessments/:jobId" element={<AssessmentsPage />} />
                <Route path="/assessments/:jobId/analytical" element={<AnalyticalAssessmentPage />} />
                <Route path="/assessments/:jobId/behavioral" element={<BehavioralAssessmentPage />} />
                <Route path="/candidate-results/:jobId" element={<CandidateResults />} />

                {/* Humanoid Simulation */}
                <Route path="/humanoid" element={<HumanoidModel />} />

                {/* Catch-all for Undefined Routes */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </div>
    );
}

export default App;

